/* eslint-disable no-unused-vars */
import Plyr from 'plyr';

const player = new Plyr('.player', {
  controls: [
    'play-large',
    'play',
    'progress',
    'current-time',
    'mute',
    'volume',
    'fullscreen'
  ],
  ratio: '16:9',
  youtube: {
    noCookie: true,
    rel: 0,
    showinfo: 0,
    iv_load_policy: 3,
    modestbranding: 1
  }
});

export default player;
